import { PortalBaseService } from 'src/portal/portal-base.service';
import { Injectable } from '@angular/core';
import { PortalProfileModel } from './portal-profile.models';
import { Operation } from 'fast-json-patch/module/core';

@Injectable({
  providedIn: 'root',
})
export class PortalProfileService extends PortalBaseService {
  public getProfile(): Promise<PortalProfileModel> {
    return this.get<PortalProfileModel>('portal/profile').toPromise();
  }

  public updateProfile(model: Operation[], userId: string): Promise<PortalProfileModel> {
    const body = JSON.stringify(model);
    return this.patch(`portal/profile/${userId}`, body).toPromise();
  }
}
